<template>
	<div>
		<div class="md:flex my-6">
			<card image="indego_bike_share.png" 
						linkTo="https://frontend.punkavechallenge.xyz/" 
						:external="true" 
						github="https://github.com/mcarson24/frontend-challenge"
						>
				<template slot="title">Indego bike-share map</template>
				A simple and easy-to-use website that displays bike share and weather information for people in Philadelphia using Indego and Open Weather Map APIs.
				<template slot="tags">
					<span>Javascript</span>
					<span>Vue.js</span>
					<span>HTML</span>
					<span>CSS</span>
				</template>
			</card>
			<card image="star_trek_50th.jpg" linkTo="https://star-trek-tweets.herokuapp.com/" :external="true" github="https://github.com/mcarson24/star-trek-50th-tweets">
				<template slot="title">Star Trek 50th Anniv. Tweets</template>
				Converting <a href="https://docs.google.com/spreadsheets/d/11hjce8KOz3WMoi_RDMtDuGe2lUUaIpnEk9fJP33UCHA/" class="underline">this</a> hideous google spreadsheet into a more palatable and readable web page in order to track behind-the-scenes Star Trek tweets.
				<template slot="tags">
					<span>PHP</span>
					<span>HTML</span>
					<span>Symfony</span>
					<span>SASS</span>
				</template>
			</card>
		</div>
		<div class="md:flex my-6">
			<card image="cat.jpg" linkTo="https://lolemipsum.herokuapp.com/" :external="true" github="https://github.com/mcarson24/lolemipsum">
				<template slot="title">LOLem Ipsum</template>
				<p class="mb-2">
					A simple and more enjoyable lorem ipsum generator created using JavaScript.
				</p>
				<p>
					KITTEHS R WEB DEVELOPRZ 2! THEY CUD NED SUM PLACEHOLDR TXT 2 DOEZ THIER DESININ.
				</p>
				<template slot="tags">
					<span>JavaScript</span>
					<span>Node.js</span>
					<span>Vue.js</span>
				</template>
			</card>
			<card image="movie_db.png" linkTo="https://snack.expo.io/@mcarson24/playful-juice-box" :external="true" 
				    github="https://github.com/mcarson24/Project-2">
				<template slot="title">Mobile Movie Browser</template>
				<p class="mb-2">
					It's like IMDB but cooler because I made it all by myself like a big boy! Written using React and React Native.
				</p>
				<p class="mb-6">
					Compatible with iOS and Android.
				</p>
				<template slot="tags">
					<span>JavaScript</span>
					<span>React</span>
					<span>React Native</span>
				</template>
			</card>
		</div>
		<div class="md:flex my-6">
			<card image="standings.png" linkTo="#" :hasLink="false" github="https://github.com/mcarson24/standings">
				<template slot="title">Command Line Baseball</template>
				You know for all those times it's too difficult to navigate to a web page to see how far back your favorite team has fallen in the standings.
				<template slot="tags">
					<span>PHP</span>
					<span>Symfony</span>
				</template>
			</card>
			<card image="simon_game.png" linkTo="/projects/simon" github="https://github.com/mcarson24/simon">
				<template slot="title">Simon</template>
				The classic Milton Bradley electronic memory game written in JavaScript using Vue.js. View the specifications <a href="https://learn.freecodecamp.org/coding-interview-prep/take-home-projects/build-a-simon-game/">here</a>.
				<template slot="tags">
					<span>JavaScript</span>
					<span>Vue.js</span>
					<span>HTML</span>
					<span>SASS</span>
				</template>
			</card>
		</div>
	</div>
</template>

<script>
	import Card from '@/components/Card.vue';
	
	export default {
		components: { Card },
		data() {
			return {

			}
		}
	}
</script>
